import { configureStore } from "@reduxjs/toolkit";
import settingsReducer from "./Slice/settingsDataSlice";
import userReducer from "./Slice/userDetails";
import productSearchReducer from './Slice/searchDataSlice'

import productDetailReducer from "./Slice/productDetailsSlice";
import cartAmountReducer from "./Slice/cartSlice";
import pageMenuDatasReducer from './Slice/PageMenu';
import pageDataReducer from "./Slice/SectionSlice";
import profilleMenuReducer from './Slice/ProfileMenuSlice'
import orderIdReducer from  './Slice/orderSlice'
const store = configureStore({
  reducer: {
    settingData: settingsReducer,
    userDetails: userReducer,
    productSearch : productSearchReducer,
    productDetails : productDetailReducer,
    cartAmountDetails : cartAmountReducer,
    pageMenus:pageMenuDatasReducer,
    pageData: pageDataReducer,
    profileMenu: profilleMenuReducer,
    orderId:orderIdReducer

  },
});
export default store;
